export default __webpack_public_path__ + "static/media/dinningRoom.3c644b9a.jpg";